<template>
    <v-card>
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                Подберите выгодный тарифный план
            </v-text>
        </div>

        <div v-padding.left="3" v-padding.right="3" v-padding.bottom="3">
            <v-alert info v-margin.bottom="3">
                <div v-padding="2">
                    <div>
                        <v-text type="subheadling">
                            Как подобрать тариф
                        </v-text>
                    </div>

                    <v-text>
                        Выберите инструменты проверки сотрудник/контрагента, которыми вы пользуетесь на UNIRATE24.
                        Укажите предполагаемое количество проверок с помощью нашего сервиса.
                        Система автоматически произведет расчет наиболее выгодного для вас тарифного плана
                        и мотивирует рекомендацию.
                    </v-text>
                </div>
            </v-alert>

            <v-row>
                <v-col xs="6">
                    <v-form :values="values" @submit="handleSubmit" :readonly="isCalculating">
                        <template scope="api">
                            <v-row v-padding.bottom="3">
                                <v-col xs="7">
                                    <v-text type="caption">
                                        Инструмент проверки
                                    </v-text>
                                </v-col>
                                <v-col xs="5">
                                    <v-text type="caption">
                                        Колличество в месяц
                                    </v-text>
                                </v-col>
                            </v-row>

                            <v-row v-padding.bottom="3" align-items="center" v-for="product in products" :key="product.id">
                                <v-col xs="7">
                                    <v-text>
                                        {{ product.name }}
                                    </v-text>
                                </v-col>
                                <v-col xs="5">
                                    <v-form-input :field="product.id.toString()" select :items="items" />
                                </v-col>
                            </v-row>

                            <v-row v-padding.bottom="3" align-items="center">
                                <v-col xs="7">
                                    <v-spinner v-if="isLoadingRequests" />
                                    <v-text v-else>
                                        <v-link to="javascript:;" @click="handleFetchRequests">
                                            Подставить мои запросы за последний месяц
                                        </v-link>
                                    </v-text>
                                </v-col>
                                <v-col xs="5">
                                    <v-spinner :active="isCalculating" block>
                                        <v-button :disabled="isLoadingRequests" primary block type="submit">
                                            подобрать
                                        </v-button>
                                    </v-spinner>
                                </v-col>
                            </v-row>
                        </template>
                    </v-form>
                </v-col>
            </v-row>
        </div>

        <v-animation-height>
            <div v-if="calculatedTariff">
                <v-separator></v-separator>

                <div v-padding="3">
                    <v-text type="headline">
                        Выгодный тарифный план
                    </v-text>

                    <v-row>
                        <v-col xs="7">
                            <v-row align-items="center">
                                <v-col xs="6">
                                    <v-text type="title" medium>
                                        {{ calculatedTariff.title }}
                                    </v-text>
                                </v-col>
                                <v-col xs="6">
                                    <v-text type="title" medium v-if="calculatedTariff.cost">
                                        {{ numberWithSpaces(calculatedTariff.cost) }} руб.
                                    </v-text>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col xs="5" v-text-align.right>
                            <v-button primary flat v-margin.right="3" @click="isShowDetails = !isShowDetails">
                                детали расчета
                            </v-button>

                            <v-router-link v-if="calculatedTariff.cost" :to="{ name: 'tariffBuy', params: { tariff: calculatedTariff.id }}">
                                <v-button primary>
                                    купить
                                </v-button>
                            </v-router-link>
                            <v-button v-else primary disabled>
                                купить
                            </v-button>
                        </v-col>
                    </v-row>

                    <tariffs-table :tariffs="tariffs" v-if="isShowDetails" v-margin.top="4" :selected="calculatedTariff.id" />
                </div>
            </div>
        </v-animation-height>
    </v-card>
</template>
<script>
    import { TariffsTable } from '../tariffsTable';
    import { numberWithSpaces } from '../../../helpers';

    export default {
        name: 'tariff-calculate',
        props: {
            tariffs: {
                type: Array,
                default() {
                    return [];
                }
            },
            products: {
                type: Array,
                default() {
                    return [];
                }
            },
            onLoadProfileRequests: Function,
            onCalculate: Function,
        },
        components: {
            TariffsTable,
        },
        data() {
            return {
                isShowDetails: false,
                isCalculating: false,
                isLoadingRequests: false,
                calculatedTariff: undefined,
                values: this.products.reduce((values, product) => {
                    values[product.id.toString()] = 0;
                    return values;
                }, {}),
                items: [
                    { id: 0, name: '0' },
                    { id: 5, name: '5' },
                    { id: 10, name: '10' },
                    { id: 20, name: '20' },
                    { id: 30, name: '30' },
                    { id: 50, name: '50' },
                    { id: 100, name: '100' },
                    { id: 200, name: '200' },
                    { id: 300, name: '300' },
                    { id: 500, name: '500' },
                    { id: 9999999, name: '500 и больше' },
                ]
            }
        },
        watch: {
            products(newProducts) {
                this.values = newProducts.reduce((values, product) => {
                    values[product.id.toString()] = 0;
                    return values;
                }, {})
            }
        },
        methods: {
            numberWithSpaces,

            handleFetchRequests() {
                this.isLoadingRequests = true;

                this.onLoadProfileRequests()
                    .then((res) => {
                        this.isLoadingRequests = false;

                        Object.keys(res.data).map((productId) => {
                            if (this.values.hasOwnProperty(productId)) {
                                this.values[productId] = res.data[productId];
                            }
                        })
                    });
            },
            handleSubmit(values) {
                if (this.isCalculating) {
                    return;
                }

                this.isCalculating = true;

                const requests = Object.keys(values).reduce((newValues, product) => {
                    newValues[product] = typeof values[product] === 'object'
                        ? values[product].id
                        : values[product];

                    return newValues;
                }, {});

                this.onCalculate(requests)
                    .then((res) => {
                        this.isCalculating = false;
                        this.calculatedTariff = res.data;
                    });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// TariffCalculate.vue?44faa0a6